export const formatMoney = (input: number) =>
  `${input < 0 ? '-' : ''}$${Math.abs(input).toFixed(2)}`;
